module.exports = __webpack_public_path__ + "img/sosmed-tiktok.f6ce2d7a.png";